import { Circle, Group, Line } from 'react-konva';
import { Vector2d } from 'konva/lib/types';
import Konva from 'konva';
import { useRef } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

type Props = Konva.GroupConfig & {
	rulerPoints: Vector2d[];
	tempPoint: { x: number; y: number } | null;
	distance: number | null;
	imageScaleX: number;
	imageScaleY: number;
};

const BASE_RADIUS = 10;

export default function CalibrationGroup(props: Props) {
	const { rulerPoints, tempPoint, distance, imageScaleX, imageScaleY, ...grpConfig } = props;
	const groupRef = useRef<Konva.Group>(null);
	const { zoomLevel } = useSelector((s: RootState) => s.toolNewPostions.data);

	const scale = Math.max(imageScaleX, imageScaleY);
	const radius = BASE_RADIUS / scale / zoomLevel;

	return (
		<Group ref={groupRef} {...grpConfig}>
			{rulerPoints.length >= 1 && tempPoint && (
				<>
					<Line
						points={[rulerPoints[0].x, rulerPoints[0].y, tempPoint.x, tempPoint.y]}
						stroke="rgba(0, 0, 0, 0.7)"
						strokeWidth={3}
						dash={[10, 5]}
						strokeScaleEnabled={false}
					/>
					<Circle
						x={rulerPoints[0].x}
						y={rulerPoints[0].y}
						radius={radius}
						fill="white"
						stroke="black"
						strokeWidth={1}
						strokeScaleEnabled={false}
					/>
				</>
			)}

			{rulerPoints.length === 2 && (
				<>
					<Line
						points={[rulerPoints[0].x, rulerPoints[0].y, rulerPoints[1].x, rulerPoints[1].y]}
						stroke="rgba(0, 0, 0, 0.7)"
						strokeWidth={3}
						dash={[10, 5]}
						strokeScaleEnabled={false}
					/>
					<Circle
						x={rulerPoints[0].x}
						y={rulerPoints[0].y}
						radius={radius}
						fill="white"
						stroke="black"
						strokeWidth={1}
						strokeScaleEnabled={false}
					/>
					<Circle
						x={rulerPoints[1].x}
						y={rulerPoints[1].y}
						radius={radius}
						fill="white"
						stroke="black"
						strokeWidth={1}
						strokeScaleEnabled={false}
					/>

					{/* {distance !== null && (
						<Text
							x={(rulerPoints[0].x + rulerPoints[1].x) / 2}
							y={(rulerPoints[0].y + rulerPoints[1].y) / 2 - 20}
							text={`${convertMetricToFeet(distance * metersPerPixel)} ft`}
							fill="white"
							// stroke="rgba(109,109, 109, 1)"
							fontSize={30}
							strokeScaleEnabled={false}
						/>
					)} */}
				</>
			)}
		</Group>
	);
}